export default {"src":"/_next/static/media/assistant-fixer-with-medium-green-text-box.0590b637.svg","height":332,"width":269};